import React, {
  Children,
  cloneElement,
  ForwardRefRenderFunction,
  isValidElement,
  useImperativeHandle,
  useState,
  forwardRef
} from 'react';
import { CSSTransition } from 'react-transition-group';
import styles from './index.module.css';

type Props = {
  side?: 'left' | 'right';
};

type Handler = {
  setIsShow: (val: boolean) => void;
};

const Shutter: ForwardRefRenderFunction<Handler, Props> = (
  { side = 'left', children },
  ref
) => {
  const [isShow, setIsShow] = useState(false);
  const { enter, enterActive, enterDone, exit, exitActive, exitDone } = styles;

  useImperativeHandle(ref, () => ({ setIsShow }));

  return (
    <div className={`${styles.wrap} ${styles[isShow ? 'visible' : 'hidden']}`}>
      <CSSTransition
        timeout={300}
        in={isShow}
        unmountOnExit
        classNames={{
          enter,
          enterActive,
          enterDone,
          exit,
          exitActive,
          exitDone
        }}
      >
        <div className={styles[side]}>
          {Children.map(children, (child) =>
            isValidElement(child) ? cloneElement(child, { setIsShow }) : null
          )}
        </div>
      </CSSTransition>
    </div>
  );
};

export default forwardRef(Shutter);
